import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Habit, loadHabits, saveHabits } from '../utils/storage';
import { getStreak, getLongestStreak, getWeekCompletions, markComplete } from '../utils/habits';
import { WeeklyGrid } from '../components/WeeklyGrid';
export const WeeklyProgress: React.FC = () => {
  const [habits, setHabits] = useState<Habit[]>([]);
  useEffect(() => {
    setHabits(loadHabits());
  }, []);
  const handleComplete = (id: string) => {
    const updatedHabits = habits.map(h => h.id === id ? markComplete(h) : h);
    setHabits(updatedHabits);
    saveHabits(updatedHabits);
  };
  // Calculate identity summary
  const identityCounts = habits.reduce((acc, habit) => {
    const weekCompletions = getWeekCompletions(habit).filter(Boolean).length;
    if (weekCompletions > 0) {
      acc[habit.identity] = (acc[habit.identity] || 0) + weekCompletions;
    }
    return acc;
  }, {} as Record<string, number>);
  const sortedIdentities = Object.entries(identityCounts).sort((a, b) => b[1] - a[1]);
  return <div className="pb-24 pt-8 px-6 max-w-md mx-auto min-h-screen" data-id="element-89">
      <header className="mb-8" data-id="element-90">
        <h1 className="text-3xl font-semibold text-gray-900 mb-2" data-id="element-91">Progress</h1>
        <p className="text-gray-500" data-id="element-92">Focus on showing up, not the outcome.</p>
      </header>

      {sortedIdentities.length > 0 && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-[#F2F7F4] border border-[#6B8F71]/20 p-5 rounded-2xl mb-8 space-y-2" data-id="element-93">
          {sortedIdentities.map(([identity, count]) => <p key={identity} className="text-gray-800 font-medium" data-id="element-94">
              You showed up as{' '}
              <span className="text-[#6B8F71] font-semibold" data-id="element-95">
                {identity.toLowerCase()}
              </span>{' '}
              {count} {count === 1 ? 'time' : 'times'} this week.
            </p>)}
        </motion.div>}

      {habits.length === 0 ? <div className="text-center py-12 text-gray-400" data-id="element-96">
          No habits to track yet.
        </div> : <div className="space-y-6" data-id="element-97">
          {habits.map((habit, index) => <motion.div key={habit.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-5 rounded-2xl border border-gray-100 shadow-sm" data-id="element-98">
              <div className="flex justify-between items-end mb-4" data-id="element-99">
                <div data-id="element-100">
                  <span className="text-xs font-medium text-gray-500 uppercase tracking-wider block mb-1" data-id="element-101">
                    {habit.identity}
                  </span>
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-102">
                    {habit.name}
                  </h3>
                </div>
                <div className="text-right" data-id="element-103">
                  <div className="text-sm text-gray-500" data-id="element-104">
                    Streak:{' '}
                    <span className="font-medium text-gray-900" data-id="element-105">
                      {getStreak(habit)}
                    </span>
                  </div>
                  <div className="text-xs text-gray-400 mt-0.5" data-id="element-106">
                    Best: {getLongestStreak(habit)}
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-50" data-id="element-107">
                <WeeklyGrid habit={habit} onCompleteToday={() => handleComplete(habit.id)} data-id="element-108" />
              </div>
            </motion.div>)}
        </div>}
    </div>;
};